import React from 'react';
import { Heading } from '@landr/maestro';
import { Trans } from '@lingui/macro';
import { css } from '@landr/styled-system/css';

export const styledTitle = css({
    fontWeight: 'bold',
    marginBottom: 'xl',
    marginTop: {
        md: 'xl',
    },
});

const ChooseYourPlan = () => (
    <Heading className={styledTitle} textStyle="title-sm">
        <Trans>Choose your option</Trans>
    </Heading>
);

export default ChooseYourPlan;
